import { render } from "./FilterBlockComponent.vue?vue&type=template&id=1a4cde5a&scoped=true"
import script from "./FilterBlockComponent.vue?vue&type=script&lang=js"
export * from "./FilterBlockComponent.vue?vue&type=script&lang=js"

import "./FilterBlockComponent.vue?vue&type=style&index=0&id=1a4cde5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4cde5a"]])

export default __exports__